import React from 'react'
import { exhibitorProfilePath } from '../functions/exhibitorProfilePath'

// Verweis auf die Aussteller-Profilseite (#239). Ein gewoehnlicher <a>: die
// Seite liegt in der Stellen-App auf einer eigenen WordPress-Seite, aus jeder
// anderen App ist sie kein Router-Ziel.
const ExhibitorProfileLink = ({ id, children }) => (
    <a className="exhibitor-profile-link" href={exhibitorProfilePath(id)}>{children}</a>
)

export default ExhibitorProfileLink
